const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Answer Question component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('answerQuestion', ['Authorization', function (Authorization) {
  return {
    restrict: 'E',
    scope: {
      question: '=',
      submitAnswer: '=',
      clearAnswer: '='
    },
    template: require('../../templates/directives/answer-question.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var user = Authorization.getAuthToken().user;

      self.answerValues = {};
      angular.forEach($scope.question.answers, function(answer) {
        self.answerValues[answer.letter] = false;
      });

      self.chooseAnswer = function(letter) {
        for (var key in self.answerValues) {
          if (key !== letter) {
            self.answerValues[key] = false;
            continue;
          }
          self.answerValues[key] = true;
          $scope.submitAnswer = letter;
        }
      };

      self.inputClick = function(number, letter) {
        var input = document.getElementById('question' + number + letter);
        setTimeout(function() {
          input.click();
        }, 1);
      };

      self.stopProp = function(evt) {
        evt.stopPropagation();
      };

      $scope.$watch('clearAnswer', function(newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }
        for (var key in self.answerValues) {
          self.answerValues[key] = false;
        }
        self.chosenValue = null;
      });
    }],
    controllerAs: 'viewAnswer'
  };
}]);